import React from "react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { TreeDropDownInput } from "../tree-pills-input/TreeInput";
import { fetchChildrenDimension, mapDimensionToDimensionItem } from "../../../api/object/Dimensions";
import useCoObjectDimensionsTextPanel, { CoObjectFieldsTextProps } from "./CoObjectDimensionsTextPanelHook";

export const CoObjectDimensionsTextPanel: React.FunctionComponent<CoObjectFieldsTextProps> = (props) => {
  const {
    objectSource,
    isLocked,
    mandatoryDimensions,
    optionalDimensions,
    inheritableParameters,
    updateDimensionFromTree,
    isComponentInstance,
  } = useCoObjectDimensionsTextPanel(props);

  if (mandatoryDimensions.length || optionalDimensions.length)
    return (
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          {[...mandatoryDimensions, ...optionalDimensions].map((dimensionItem) => (
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" key={dimensionItem.type + "-dropdown"}>
              <TreeDropDownInput
                fetchRoot={async (oid) => {
                  const items = await fetchChildrenDimension(objectSource?.dbApplication?.id, oid);
                  return items.map((i) => mapDimensionToDimensionItem(i, false));
                }}
                fetchChildren={async (item) => {
                  const items = await fetchChildrenDimension(objectSource?.dbApplication?.id, item.data.oid);
                  return items.map((i) => mapDimensionToDimensionItem(i, false));
                }}
                dimensions={objectSource?.dimensions?.filter((d) => d.dimensionOid === dimensionItem.oid)}
                label={dimensionItem.mandatory ? dimensionItem.desc + " *" : dimensionItem.desc}
                modalTitle={dimensionItem.desc}
                placeholder={formatMessage("cof.base.select")}
                rootOid={dimensionItem.oid}
                hierarchical={dimensionItem.hierarchical}
                canInherit={inheritableParameters?.filter((d) => d.dimensionOid === dimensionItem.oid) ?? []}
                inherited={objectSource?.dimensions?.find((d) => d.dimensionOid === dimensionItem.oid)?.inherited}
                multiSelectable={false}
                onChange={(newDimension) => {
                  // eslint-disable-next-line no-undef
                  updateDimensionFromTree(dimensionItem, newDimension);
                }}
                dbId={objectSource?.dbApplication?.id}
                disabled={isComponentInstance || isLocked}
                isSearchAvailable={true}
                referringScenarios={props.referringScenarios}
              />
            </div>
          ))}
        </div>
      </div>
    );
  else
    return (
      <div
        style={{
          backgroundColor: "var(--color-yellow-a20)",
          fontSize: "1rem",
          margin: "1.25rem 1.25rem 1.25rem 1.25rem",
          padding: "0.5rem 1.25rem 0.5rem 1.25rem",
        }}
      >
        {formatMessage("cof.createnewobject.noparameters.info")}
      </div>
    );
};
